import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ImportacaoTalaoItau } from 'src/app/@shared/models/importacoes/importacoes.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ImportacaoService {

  constructor(private http: HttpClient) { }

  uploadExcel(fileInput: any): Observable<any[]> {
    return this.http.put<any[]>(`ImportaTalaoItau/UploadExcel`, fileInput, httpOptions);
  }

  processaItens(obj: any[]): Observable<any> {
    return this.http.post<any>('ImportaTalaoItau/ProcessaItens', obj, httpOptions);
  }


}
